import { brandName } from "./branding";
import blackLogo from "./assets/black.png";
import whiteLogo from "./assets/white.png";

export type BrandLogoVariant = "white" | "black";

export interface IBrandLogoProps {
    variant?: BrandLogoVariant;
    height?: number;
    className?: string;
}

export const BrandLogo = ({
    variant = "black",
    height = 28,
    className
}: IBrandLogoProps) => {
    const logo = (variant === "white" ? whiteLogo : blackLogo) as string;

    return (
        <img
            src={logo}
            alt={brandName}
            className={className}
            style={{
                height,
                width: "auto",
                objectFit: "contain",
                objectPosition: "left center",
                display: "block"
            }}
        />
    );
};

export default BrandLogo;
